import { debounce } from './helpers/utilities';
import lazyLoader from './modules/lazyLoader';
import promoBar from './modules/promoBar';
import primaryHero from './modules/primaryHero';
import featuredCollection from './modules/featuredCollection';
import instagramFeed from './modules/instagramFeed';
import collectionGrid from './modules/collectionGrid';
import recentlyViewed from './modules/recentlyViewed';
import addToBag from './modules/addToBag';
import miniBasket from './modules/miniBasket';
import gallery from './modules/gallery';
import productOptions from './modules/productOptions';
import filters from './modules/filters';
import productGroup from './helpers/productGroup';
import productColors from './modules/productColors';
import productTestimonials from './modules/productTestimonials';
import quantity from './modules/quantity';
import overlay from './modules/overlay';
import btnCheckout from './modules/btnCheckout';
import menu from './modules/menuSlideout';
import menuDropdown from './modules/menuDropdown';
import lineItemTable from './modules/lineItemTable';
import reviews from './modules/reviews';
import modal from './modules/modal';
import login from './modules/login';
import searchBar from './modules/searchBar';
import cookieConsent from './modules/cookieConsent';
import accordion from './modules/accordion';

export default class App {
  init() {
    document.addEventListener('DOMContentLoaded', this.load);
    document.addEventListener('resize', this.resize);
  }

  load() {
    accordion.init();
    lazyLoader.init();
    overlay.init();
    promoBar.init();
    primaryHero.init();
    featuredCollection.init();
    recentlyViewed.init();
    collectionGrid.init();
    gallery.init();
    addToBag.init();
    productOptions.init();
    instagramFeed.init();
    miniBasket.init();
    filters.init();
    quantity.init();
    btnCheckout.init();
    menu.init();
    menuDropdown.init();
    modal.init();
    searchBar.init();
    productTestimonials.init();
    productGroup.init();
    productColors.init();
    reviews.init();
    login.init();
    lineItemTable.init();
    cookieConsent.init();
  }

  private resize = debounce((node:HTMLElement) => {
    accordion.load();
  }, 250);
}